export default __webpack_public_path__ + "static/media/hht1_ep05_timeline_q05_a.8619652d.png";